var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pointer",on:{"click":function (){_vm.collection(_vm.id,_vm.collections)  }}},[(!_vm.loading)?_c('i',{class:_vm.collections==null?  'iconfont icon-shoucang':'iconfont icon-collection-b'}):_c('i',{staticClass:"el-icon-loading"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-085daa72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_widget/Operation.vue
// module id = null
// module chunks = 